import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useAuth } from "@/context/AppContext";

// Another tab of this browser logged in with a different account: this tab stops and asks to reload (no logout, no revocation).
export function SwitchedOverlay() {
  const { switched } = useAuth();
  if (!switched) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-md p-6" data-testid="session-switched-overlay">
      <div className="max-w-sm w-full rounded-xl border border-[#232738] bg-[#0D0E14] p-6 text-center">
        <p className="text-base font-semibold text-slate-100" data-testid="session-switched-text">Hai effettuato l'accesso con un altro account in un'altra scheda</p>
        <p className="text-xs text-slate-500 mt-2">Le schede dello stesso browser usano lo stesso accesso. Ricarica per continuare con l'account attivo.</p>
        <Button onClick={() => window.location.reload()} className="mt-5 w-full bg-violet-600 hover:bg-violet-500" data-testid="session-switched-reload">
          <RefreshCw className="h-4 w-4 mr-2" />Ricarica
        </Button>
      </div>
    </div>
  );
}

export function LogoutAllDialog({ open, onOpenChange }) {
  const { logout } = useAuth();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-[#0D0E14] border-[#232738]" data-testid="logout-all-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Vuoi uscire da tutti i dispositivi?</AlertDialogTitle>
          <AlertDialogDescription>Dovrai accedere di nuovo ovunque.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="logout-all-cancel">Annulla</AlertDialogCancel>
          <AlertDialogAction onClick={() => logout(true)} className="bg-red-600 hover:bg-red-500" data-testid="logout-all-confirm">Esci ovunque</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
